import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function LandingNavigation() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-b ${
        scrolled
          ? "bg-dark-primary/90 backdrop-blur-xl border-dark-border"
          : "bg-transparent border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/home" className="flex items-center gap-2 group">
            {/* If there is an image logo, use it, or fallback to text. The old file used /G1.svg */}
            <img src="/G1.svg" alt="SuBs" className="w-10 h-10 object-contain" onError={(e) => { e.currentTarget.style.display = 'none'; }} />
            <span className="text-2xl font-black font-outfit tracking-tighter text-text-primary group-hover:text-golden-accent transition-colors">
              SuBs
            </span>
          </Link>

          {/* Desktop Nav Links - REMOVED per user request */}
          <div className="hidden lg:flex items-center gap-8">
            {/* Links removed */}
          </div>

          {/* Desktop CTA */}
          <div className="hidden lg:flex items-center gap-6 ml-auto">
            <Link
              to="/login"
              className="px-5 py-2 text-sm font-medium text-text-secondary hover:text-text-primary transition-colors uppercase tracking-wide"
            >
              Log In
            </Link>
            <Link
              to="/register/admin"
              className="px-6 py-2.5 text-sm font-semibold text-dark-primary bg-golden-accent rounded-full border border-golden-accent shadow-[0_8px_24px_rgba(255,188,6,0.2)] hover:bg-[#ffd75a] hover:shadow-[0_12px_28px_rgba(255,188,6,0.28)] transition-all uppercase tracking-wide"
            >
              Register Now
            </Link>
          </div>

          {/* Mobile Hamburger - REMOVED since only buttons remain */}
          <div className="lg:hidden flex items-center gap-4">
               <Link
                    to="/login"
                    className="text-sm font-medium text-text-secondary hover:text-text-primary"
                >
                    Log In
                </Link>
                 <Link
                  to="/register/admin"
                    className="px-4 py-2 text-sm font-bold text-dark-primary bg-golden-accent rounded-full"
                >
                  Register
                </Link>
          </div>
        </div>
      </div>

      {/* Mobile Menu - REMOVED */}
    </nav>
  );
}
